export enum JobTypeMCQEnum {
  CREATE_MCQS = "CREATE_MCQS",
  REVIEW_MCQS = "REVIEW_MCQS",
}
